import ApiFactory from './factory'
import declaration from './declarations'

/** @type {ApiFactory & Record<string, any>} */
const Api = new ApiFactory(import.meta.env.VITE_API_BASE_URL + 'v3', declaration)

export default Api
